import SpLink from "@components/shared/SpLink";
import SECURE_SIMPLEPRACTICE_SIGNIN from "@constants/secureSpSignIn";
import { FormSteps, useSignupFormDrip } from "@sp-state/useSignupFormDrip";
import React, { useEffect } from "react";
import FormContent from "./sfd-components/FormContent";
import FormProgress from "./sfd-components/FormProgress";

import styles from "./SignupFormDrip.module.scss";
import FormCookieMessage from "@components/SignUpForm/FormCookieMessage/FormCookieMessage";
import { useFormData } from "@sp-state/useFormData";

export type SignupFormDripType = {
  steps: FormSteps;
  lastStepCta?: string;
};

export type questionsInitialType = {
  [key: string]: {
    value: string[];
    hasError: false;
    isValid: false;
    questionName: string | undefined;
  };
};

const SignupFormDrip: React.FC<SignupFormDripType> = props => {
  const { setSteps, getIsFirstStep, getPromoCode, setLastStepCta } =
    useSignupFormDrip(state => state);

  const { setInitialQuestionValues } = useFormData();

  const isFirstStep = getIsFirstStep();

  const promoCode = getPromoCode();

  useEffect(() => {
    setLastStepCta(props?.lastStepCta);
  }, [props?.lastStepCta, setLastStepCta]);

  useEffect(() => {
    if (!props?.steps) return;

    setSteps(props?.steps);
  }, [props?.steps, setInitialQuestionValues, setSteps]);

  useEffect(() => {
    const fields = props?.steps?.map(item => item.fields);

    if (!fields || !fields.length) return;

    const newObj = {} as questionsInitialType;

    fields.flatMap(innerArray =>
      innerArray?.forEach(item => {
        const questionName = item?.questionAttributes?.questionName || "";

        if (item?.field === "questions" && item?.questionAttributes) {
          newObj[questionName] = {
            ...item?.questionAttributes,
            isValid: false,
            hasError: false,
            value: [],
            questionName,
          };
        }
      })
    );

    setInitialQuestionValues(newObj);
  }, [props?.steps, setInitialQuestionValues]);

  return (
    <section className={styles.wrapper}>
      <FormProgress />
      {isFirstStep && promoCode && (
        <FormCookieMessage
          cookie={promoCode}
          externalClass={styles.promoCode}
        />
      )}
      <FormContent />

      {isFirstStep && (
        <p className={styles.copy}>
          Already have an account?{" "}
          <SpLink path={SECURE_SIMPLEPRACTICE_SIGNIN}>Sign in</SpLink>.
        </p>
      )}
    </section>
  );
};

export default SignupFormDrip;
